export default {
  "HitPaw Online Audio Extractor": "HitPawオンライン音声抽出機",
  "Extract sound from videos with ease.": "動画から音を簡単に抽出します。",
  "Select Audio Format": "音声データ形式を選択する",
  "Extract Audio": "音声データを抽出する",
  "Extracting Audio": "音声データ抽出",
  "Extracted Successfully": "抽出成功",
  "Extract New": "新しいものを抽出する",
  "Extraction Failed": "抽出失敗",
  "Format": "形式",
};
